import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import { DateTime } from "../../../../";

var TickerItem = /*#__PURE__*/function (_Component) {
  _inherits(TickerItem, _Component);

  var _super = _createSuper(TickerItem);

  function TickerItem(props) {
    var _this;

    _classCallCheck(this, TickerItem);

    _this = _super.call(this, props);
    _this.getClassName = getClassNameFactory("TickerItem");
    return _this;
  }

  _createClass(TickerItem, [{
    key: "render",
    value: function render() {
      var titleEl = /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "title",
          modifiers: this.props.dateTime ? "dated" : ""
        })
      }, this.props.title);
      var timeEl = this.props.dateTime ? /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "time"
        })
      }, /*#__PURE__*/React.createElement(DateTime, {
        currentTime: this.props.currentTime,
        dateTime: this.props.dateTime,
        lang: this.props.lang,
        relative: true
      })) : null;
      return /*#__PURE__*/React.createElement("li", {
        className: this.getClassName({
          utilities: this.props.lead ? "typographySmallCaps" : ""
        }),
        "data-rehydratable": getRehydratableName(TickerItem.displayName),
        "data-date-time": this.props.dateTime,
        "data-href": this.props.href,
        "data-lang": this.props.lang,
        "data-lead": this.props.lead,
        "data-title": this.props.title
      }, this.props.href ? /*#__PURE__*/React.createElement("a", {
        href: this.props.href,
        className: this.getClassName({
          descendantName: "link"
        })
      }, titleEl, timeEl) : /*#__PURE__*/React.createElement("span", null, titleEl, timeEl));
    }
  }]);

  return TickerItem;
}(Component);

_defineProperty(TickerItem, "displayName", "Ticker.Item");

_defineProperty(TickerItem, "propTypes", {
  /**
   * An ISO 8601, RFC 2822, or `new Date(str)` compatible date string, which is used to compare relative time. Defaults to the time that the current page loaded; you should set this if you want the time to dynamically update as time progresses.
   */
  currentTime: PropTypes.string,

  /**
   * An ISO 8601, RFC 2822 or `new Date(str)` compatible date string.
   */
  dateTime: PropTypes.string,

  /**
   * A link to this story. Will render without an anchor element if this is not provided.
   */
  href: PropTypes.string,

  /**
   * The language of this item. Used to localize the relative time.
   */
  lang: PropTypes.string,

  /**
   * Whether this should display as the first item or not.
   */
  lead: PropTypes.bool,

  /**
   * The title of this item.
   */
  title: PropTypes.string.isRequired
});

_defineProperty(TickerItem, "defaultProps", {
  lang: "en"
});

export default TickerItem;